"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4669],{

/***/ 54669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97133);
/* harmony import */ var _prezzee_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34906);
/* harmony import */ var _prezzee_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_prezzee_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var contexts_ProductPageContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16029);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31758);





var style = {
    title: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("font-weight:600;"),
    accordionPanel: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("font-weight:300;padding-bottom:20px;p{margin-bottom:1em;}ul,ol{margin-bottom:1em;list-style:inherit;padding-left:2.5em;}")
};
var FullCardDetails = function() {
    var sku = ((0,contexts_ProductPageContext__WEBPACK_IMPORTED_MODULE_2__/* .useProduct */ .i)() || {}).sku;
    if (!sku.description) return null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_prezzee_components__WEBPACK_IMPORTED_MODULE_1__.Accordion, {
        allowZeroExpanded: true,
        variant: "secondary",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_prezzee_components__WEBPACK_IMPORTED_MODULE_1__.AccordionItem, {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_prezzee_components__WEBPACK_IMPORTED_MODULE_1__.AccordionItemHeading, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_prezzee_components__WEBPACK_IMPORTED_MODULE_1__.AccordionItemButton, {
                        children: "Read the full details"
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_prezzee_components__WEBPACK_IMPORTED_MODULE_1__.AccordionItemPanel, {
                    className: style.accordionPanel,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_4__/* .ReactMarkdown */ .D, {
                        children: sku.description
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FullCardDetails);


/***/ })

}]);